import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";
const DISMISS_KEY = "oryyn_dismissed_announcement";

const LEVEL_ICON = { info: "📣", success: "✅", warning: "⚠️" };

export default function AnnouncementBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_URL}/announcement`)
      .then((res) => {
        const a = res.data?.announcement;
        if (cancelled || !a) return;
        if (localStorage.getItem(DISMISS_KEY) === String(a.id)) return;
        setData(a);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(data.id));
    setData(null);
  };

  const level = LEVEL_ICON[data.level] ? data.level : "info";

  return (
    <div className={`announcement-banner announcement-${level}`} role="status">
      <span className="announcement-icon">{LEVEL_ICON[level]}</span>
      <span className="announcement-text">
        {data.message}
        {data.link ? (
          <a
            className="announcement-link"
            href={data.link}
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </a>
        ) : null}
      </span>
      <button
        className="announcement-close"
        onClick={dismiss}
        type="button"
        aria-label="Dismiss announcement"
      >
        ✕
      </button>
    </div>
  );
}
